import React from 'react';
import AppStoreLink from './AppStoreLink';
import Phone from './Phone';
import HeroAmbient from './HeroAmbient';
import todayWebp from '../assets/screens/today.webp';
import todayPng from '../assets/screens/today.png';

/**
 * Hero (handoff §2): two columns, the phone on the right behind an accent
 * glow. The phone shows the app's Today screen - a 2× image export, and the
 * page's LCP element: fetched at high priority, sized explicitly and never
 * lazy-loaded. It is imported (not served from public/) so its URL carries a
 * content hash - the old copy sat in browser and CDN caches for hours after
 * every refresh because the filename never changed. No entry animation here: first paint stays instant.
 * The one ambient element is the canvas behind the phone (HeroAmbient); it
 * paints after mount and is skipped entirely under prefers-reduced-motion.
 */
const Hero = () => (
  <section className="hero" id="home">
    <div className="hero-copy">
      <div className="chip">
        <span className="chip-dot" />
        Now on the App Store · iOS 17+
      </div>
      <h1 className="h1">
        Photograph dinner.
        <br />
        Get the recipe.
      </h1>
      <p className="lead">
        Snapcipe reads a photo of any dish - or the inside of your fridge, or a page of a cookbook -
        and writes the recipe back. Ingredients, method, timings, nutrition.
      </p>
      <div className="hero-ctas">
        <AppStoreLink />
        <a href="#how" className="cta-secondary">
          See how it works
        </a>
      </div>
      <div className="hero-stats">
        <div>
          <div className="mono hero-stat-num">5</div>
          <div className="body-copy hero-stat-label">scan modes</div>
        </div>
        <div>
          <div className="mono hero-stat-num">7</div>
          <div className="body-copy hero-stat-label">free AI actions a month, with an account</div>
        </div>
        <div>
          <div className="mono hero-stat-num">$0</div>
          <div className="body-copy hero-stat-label">to start, no card</div>
        </div>
      </div>
    </div>

    <div className="hero-visual">
      <HeroAmbient />
      <div className="hero-glow" aria-hidden="true" />
      <Phone
        webp={todayWebp}
        png={todayPng}
        alt="The Snapcipe Today screen: a cooking card for a salmon avocado bowl at step 3 of 7 with Next step and Open buttons, the capture group, the local-dishes row, the day's intake at 1,420 of 2,000 kcal with macros, and cook-next suggestions, above a floating tab bar with the centre shutter."
        eager
      />
    </div>
  </section>
);

export default Hero;
